import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { track } from "../lib/track";

const base =
  "group inline-flex w-full items-center justify-center gap-3 rounded-[3px] px-7 py-3.5 text-[0.7rem] font-medium uppercase tracking-[0.18em] transition-colors duration-300 sm:w-auto";

const arrow = "h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-1";

export const ButtonPrimary = ({ to, href, children, testid, event, className = "" }) => {
  const cls = `${base} border border-[#C6A46A] bg-[#C6A46A] text-[#171717] hover:border-[#171717] hover:bg-[#171717] hover:text-[#F4F0E8] ${className}`;
  const inner = (
    <>
      <span>{children}</span>
      <ArrowRight className={arrow} />
    </>
  );
  const onClick = () => event && track(event);
  if (to)
    return (
      <Link to={to} className={cls} data-testid={testid} onClick={onClick}>
        {inner}
      </Link>
    );
  return (
    <a href={href} className={cls} data-testid={testid} onClick={onClick}>
      {inner}
    </a>
  );
};

// tone: "dark" (on carbon) | "light" (on ivory)
export const ButtonSecondary = ({ to, href, children, testid, tone = "dark", event, className = "" }) => {
  const colors =
    tone === "dark"
      ? "border-[#F4F0E8]/30 text-[#F4F0E8] hover:border-[#C6A46A] hover:text-[#C6A46A]"
      : "border-[#171717]/30 text-[#171717] hover:border-[#C6A46A] hover:text-[#8a6f3e]";
  const cls = `${base} border bg-transparent ${colors} ${className}`;
  const inner = (
    <>
      <span>{children}</span>
      <ArrowRight className={arrow} />
    </>
  );
  const onClick = () => event && track(event);
  if (to)
    return (
      <Link to={to} className={cls} data-testid={testid} onClick={onClick}>
        {inner}
      </Link>
    );
  return (
    <a href={href} className={cls} data-testid={testid} onClick={onClick}>
      {inner}
    </a>
  );
};
